import { isRetryable } from '@cascade/core/errors';
import { useI18n } from '@cascade/react/i18n';
import { Button } from '@cascade/ui-library';
import { useNavigate } from 'react-router-dom';
import classes from './FailureActions.module.scss';
import type { TFailureActionsProps } from './FailureActions.types.ts';
import { HOME_PATH } from '#config/index.ts';

export const FailureActions = ({ error, onRetry }: TFailureActionsProps) => {
  const { translate } = useI18n();
  const navigate = useNavigate();

  const showRetry = isRetryable(error);

  const navigateHome = () => navigate(HOME_PATH, { replace: true });

  return (
    <div className={classes['failure-actions']}>
      <Button
        variant={showRetry ? 'secondary' : 'primary'}
        ghost={showRetry}
        label={translate('failure.home')}
        onClick={navigateHome}
      />
      {showRetry ? (
        <Button label={translate('failure.retry')} onClick={onRetry} />
      ) : null}
    </div>
  );
};
